import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import {
  LastPage,
  AllInclusive,
  Add,
  MoreVert,
  Schedule,
  Block,
  Subway,
  AirportShuttle,
  SupervisedUserCircle,
  Edit,
  Delete,
  SwapHoriz,
  Done,
  Folder,
  Person,
  Visibility,
  People,
  CheckCircleOutline,
  AccountCircle,
  AccountBalanceWallet,
  OpenInBrowser,
  CancelPresentation,
} from "@material-ui/icons";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Grid,
  FormHelperText,
  CircularProgress,
} from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";

import { useSnackbar } from "notistack";

import axios from "axios";

import {
  TransportService,
  AdminService,
  FinanceService,
} from "../../utils/web_config_2";

import UserInfo from "./login_info";

import Skeleton from "@material-ui/lab/Skeleton";

import { useHistory } from "react-router-dom";

import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  btn: {
    textTransform: "capitalize",
  },
  formTitle: {
    flexGrow: 1,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
  },
}));

function Managers() {
  const classes = useStyles1();
  const Theme = useTheme();
  const history = useHistory();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [agentData, setagentData] = useState({});

  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  // dialog new assistant
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [open, setOpen] = useState(false);

  // block user

  const handleOpenBlock = () => {
    setOpenBlock(true);
  };

  const handleCloseBlock = () => {
    setOpenBlock(false);
  };

  const [openBlock, setOpenBlock] = useState(false);

  useEffect(() => {
    var profile = localStorage.getItem("agent_profile");

    var data = {};
    const data1 = localStorage.getItem("nx_ag");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setagentData(data);
    axios.defaults.baseURL = new FinanceService().BASE_URL;

    get_assistants(data.token);
    get_roles(data.token);
  }, []);

  const [assistantMessage, setAssistantMessage] = useState("");
  const [assistantLoad, setAssistantLoad] = useState(false);
  const [assistants, setAssistants] = useState([]);
  const get_assistants = (token) => {
    console.log("user login", localStorage.getItem("data"));
    setAssistantLoad(true);
    const assistantInstance = axios.create(
      new AdminService().setHeaders(token)
    );
    assistantInstance.defaults.baseURL = new AdminService().BASE_URL;
    assistantInstance
      .get(
        "/admin-service/api/v1/user/organization/" +
          new UserInfo().ORG_ID +
          "/type/AGENT_MANAGER"
      )
      .then((res) => {
        console.log("Assistant");
        setAssistantLoad(false);
        var objs = res.data.data;
        if (objs.length == 0) {
          setAssistantMessage("No Sub Agent available!");
          enqueueSnackbar("No Sub Agent available!", {
            variant: "Info",
          });
        } else {
          console.log(objs);
          setAssistants(objs);
        }
      })
      .catch((err) => {
        setAssistantLoad(false);

        if (err.response.status == 404) {
          setAssistantMessage("No Sub Agent available!");
          enqueueSnackbar(err.response.data.message, {
            variant: "Info",
          });
        }

        // enqueueSnackbar(err.message, {
        //       variant: "error",

        //     });

        if (err.response.status == 401) {
          history.push("/", { expired: true });
          enqueueSnackbar("Your session has expired", {
            variant: "error",
          });
        }

        // if (err.response.status == 404) {
        //   setAssistantMessage("No Sub Agent available!");
        //   enqueueSnackbar("No sub Agent available", {
        //     variant: "info",

        //   });
        // }
      });
  };

  // get agent details
  const [agentDetails, setAgentDetails] = useState({});
  const get_details = (id) => {
    var obj = assistants.find((a) => a.user_id == id);
    setAgentDetails(obj);
  };

  // fetch roles

  const [roles, setRoles] = useState([]);
  const get_roles = (token) => {
    const rolesInstance = axios.create(new AdminService().setHeaders(token));
    rolesInstance
      .get("/admin-service/api/v1/role/organization/" + new UserInfo().ORG_ID)
      .then((res) => {
        setRoles(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // new assistant

  const [newLoad, setNewLoad] = useState(false);
  const [email, setEmail] = useState({ value: "", error: "" });
  const [Fname, setFname] = useState({ value: "", error: "" });
  const [Lname, setLname] = useState({ value: "", error: "" });
  const [gender, setGender] = useState({ value: "", error: "" });
  const [userName, setUsername] = useState({ value: "", error: "" });
  const [nid, setNid] = useState({ value: "", error: "" });
  const [password, setPassword] = useState({ value: "", error: "" });
  const [phone, setPhone] = useState({ value: "", error: "" });
  const [pin, setPin] = useState({ value: "", error: "" });
  const [role, setRole] = useState({ value: 0, error: "" });

  const new_user = () => {
    if (email.value === "") {
      setEmail({ value: "", error: "Enter email" });
    } else if (Fname.value === "") {
      setFname({ value: "", error: "Enter first name" });
    } else if (Lname.value === "") {
      setLname({ value: "", error: "Enter lastname" });
    } else if (gender.value === "") {
      setGender({ value: "", error: "Select gender" });
    } else if (userName.value === "") {
      setUsername({ value: "", error: "Enter Username" });
    } else if (nid.value === "") {
      setNid({ value: "", error: "Enter NID" });
    } else if (password.value === "") {
      setPassword({ value: "", error: "Enter password" });
    } else if (phone.value === "") {
      setPhone({ value: "", error: "Enter phone" });
    } else if (role.value == 0) {
      setRole({ value: 0, error: "Select role" });
    } else {
      setNewLoad(true);
      const newInstance = axios.create(
        new AdminService().setHeaders(agentData.token)
      );
      newInstance
        .post("/admin-service/api/v1/user", {
          organization_id: new UserInfo().ORG_ID,
          role_id: role.value,
          user_email: email.value,
          user_first_name: Fname.value,
          user_gender: gender.value,
          user_last_name: Lname.value,
          user_name: userName.value,
          user_nid: nid.value,
          user_password: password.value,
          user_phone: phone.value,
          user_pin: pin.value,
          user_type: "AGENT",
        })
        .then((res) => {
          var obj = res.data.data;

          var u = assistants;
          u.unshift(obj);
          setAssistants(u);

          get_assistantInfo();
        })
        .catch((err) => {
          setNewLoad(false);
          console.log(err);
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        });
    }
  };

  // update agent profile

  const get_assistantInfo = () => {
    const assistantInstance = axios.create(
      new AdminService().setHeaders(agentData.token)
    );
    assistantInstance
      .get(
        "/admin-service/api/v1/user/organization/" +
          new UserInfo().ORG_ID +
          "/type/AGENT_MANAGER"
      )
      .then((res) => {
        localStorage.removeItem("agent_profile");
        localStorage.setItem("agent_profile", JSON.stringify(res.data.data));

        setOpen(false);
        setNewLoad(false);
        enqueueSnackbar("New assistants added successifuly!", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      })
      .catch((err) => {
        if (err.response.status == 401) {
          history.push("/", { expired: true });
          enqueueSnackbar("Your session has expired", {
            variant: "error",
          });
        }
      });
  };

  // deactive assistaent

  const [assistantId, setAssistantId] = useState(0);
  const [deactivateLoad, setDeactivateLoad] = useState(false);
  const deactive_user = () => {
    setDeactivateLoad(true);
    const deactiveInstance = axios.create(
      new AdminService().setHeaders(agentData.token)
    );
    deactiveInstance
      .put("/admin-service/api/v1/user/status/deactivate/" + assistantId)
      .then((res) => {
        handleCloseBlock();

        setDeactivateLoad(false);

        var u = assistants.find((i) => i.user_id == assistantId);
        u["user_status"] = "DISABLED";
        var index = assistants.findIndex((i) => i.user_id == assistantId);
        let newArr = [...assistants];
        newArr[index] = u;

        setAssistants(newArr);

        enqueueSnackbar("Assistant deactivated successful!", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      })
      .catch((err) => {
        console.log(err);
        setDeactivateLoad(false);
        enqueueSnackbar(err.message, {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      });
  };

  // reactive assistant dialog
  const [activeDialog, setActiveDialog] = useState(false);

  // reactive assistant

  const [activeLoad, setActiveLoad] = useState(false);
  const active_user = () => {
    setActiveLoad(true);
    const activeInstance = axios.create(
      new AdminService().setHeaders(agentData.token)
    );
    activeInstance
      .put("/admin-service/api/v1/user/status/reactivate/" + assistantId)
      .then((res) => {
        setActiveDialog(false);
        setActiveLoad(false);

        var u = assistants.find((i) => i.user_id == assistantId);
        u["user_status"] = "ENABLED";

        var index = assistants.findIndex((i) => i.user_id == assistantId);

        let newArr = [...assistants];
        newArr[index] = u;

        setAssistants(newArr);

        enqueueSnackbar("User reactivated successful!", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      })
      .catch((err) => {
        console.log(err);
        setActiveLoad(false);

        enqueueSnackbar(err.message, {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      });
  };

  // get info dialog
  const [infoDialog, setInfoDialog] = useState(false);

  //get info details
  const [info, seInfo] = useState({});
  const get_assistant_info = (id) => {
    var obj = assistants.find((a) => a.user_id == id);
    seInfo(obj);
    setInfoDialog(true);
  };

  // dialog balance

  const [balanceDialog, setBalanceDialog] = useState(false);

  // get balance
  const [accountNumber, setAccountNumber] = useState("");
  const [balanceData, setBalanceData] = useState({});
  const [balanceLoad, setBalanceLoad] = useState(false);
  const get_balance = (phone_number) => {
    console.log("phone number", phone_number);
    setBalanceLoad(true);
    setBalanceDialog(true);
    const balanceInstance = axios.create(
      new FinanceService().setHeaders(agentData.token)
    );
    balanceInstance
      .get("/nxfinance/api/v1/getWalletByPhoneNumber/" + phone_number)
      .then((res) => {
        var data = res.data.data;
        setBalanceData(data);
        setBalanceLoad(false);
      })
      .catch((err) => {
        setBalanceLoad(false);
        enqueueSnackbar(err.message, {
          variant: "error",
        });

        if (err.response.status == 401) {
          history.push("/", { expired: true });
          enqueueSnackbar("Your session has expired", {
            variant: "error",
          });
        }

        if (err.response.status == 404) {
          setBalanceLoad(false);
          setBalanceDialog(false);
          enqueueSnackbar("Agent doesn't have wallet!", {
            variant: "error",
          });
        }
      });
  };

  return (
    <div className={classes.root}>
    
      <Box display="flex">
        <Box
          display="flex"
          alignItems="center"
          mt={2}
          className={classes.formTitle}
        >
          <Box mr={1}>
            {" "}
            <People fontSize="large" color="primary" />
          </Box>{" "}
          <Typography variant="h5" color="default">
            <b>
              <Translate id="agent_assistant.assistant" />
            </b>
          </Typography>
        </Box>

        <Button
          className={classes.btn}
          size="small"
          startIcon={<Add />}
          onClick={() => {
            handleClickOpen();
          }}
          variant="contained"
          color="primary"
          disableElevation={true}
        >
          <Typography noWrap>
            <Translate id="agent_assistant.new_assistant" />
          </Typography>
        </Button>
      </Box>

      {/* user list  */}

      {assistantLoad ? (
        <Box mt={2} className={classes.paper}>
          <Box mb={1}>
            <Grid container>
              <Grid md={1} sm={1} lg={1} xs={2}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={40}
                    height={40}
                  />
                </Box>
              </Grid>
              <Grid md={9} sm={9} lg={9} xs={8}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="40%"
                    style={{ marginBottom: 6 }}
                  />
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="60%"
                    style={{ marginBottom: 6 }}
                  />
                </Box>
              </Grid>
              <Grid md={2} sm={2} lg={2} xs={2}>
                <Box ml={1} mt={2}>
                  <Grid container>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box mb={1}>
            <Grid container>
              <Grid md={1} sm={1} lg={1} xs={2}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={40}
                    height={40}
                  />
                </Box>
              </Grid>
              <Grid md={9} sm={9} lg={9} xs={8}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="40%"
                    style={{ marginBottom: 6 }}
                  />
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="60%"
                    style={{ marginBottom: 6 }}
                  />
                </Box>
              </Grid>
              <Grid md={2} sm={2} lg={2} xs={2}>
                <Box ml={1} mt={2}>
                  <Grid container>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box mb={1}>
            <Grid container>
              <Grid md={1} sm={1} lg={1} xs={2}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={40}
                    height={40}
                  />
                </Box>
              </Grid>
              <Grid md={9} sm={9} lg={9} xs={8}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="40%"
                    style={{ marginBottom: 6 }}
                  />
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="60%"
                    style={{ marginBottom: 6 }}
                  />
                </Box>
              </Grid>
              <Grid md={2} sm={2} lg={2} xs={2}>
                <Box ml={1} mt={2}>
                  <Grid container>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box mb={1}>
            <Grid container>
              <Grid md={1} sm={1} lg={1} xs={2}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={40}
                    height={40}
                  />
                </Box>
              </Grid>
              <Grid md={9} sm={9} lg={9} xs={8}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="40%"
                    style={{ marginBottom: 6 }}
                  />
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="60%"
                    style={{ marginBottom: 6 }}
                  />
                </Box>
              </Grid>
              <Grid md={2} sm={2} lg={2} xs={2}>
                <Box ml={1} mt={2}>
                  <Grid container>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box mb={1}>
            <Grid container>
              <Grid md={1} sm={1} lg={1} xs={2}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={40}
                    height={40}
                  />
                </Box>
              </Grid>
              <Grid md={9} sm={9} lg={9} xs={8}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="40%"
                    style={{ marginBottom: 6 }}
                  />
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="60%"
                    style={{ marginBottom: 6 }}
                  />
                </Box>
              </Grid>
              <Grid md={2} sm={2} lg={2} xs={2}>
                <Box ml={1} mt={2}>
                  <Grid container>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box mb={1}>
            <Grid container>
              <Grid md={1} sm={1} lg={1} xs={2}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={40}
                    height={40}
                  />
                </Box>
              </Grid>
              <Grid md={9} sm={9} lg={9} xs={8}>
                <Box ml={1} mt={1}>
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="40%"
                    style={{ marginBottom: 6 }}
                  />
                  <Skeleton
                    animation="wave"
                    height={10}
                    width="60%"
                    style={{ marginBottom: 6 }}
                  />
                </Box>
              </Grid>
              <Grid md={2} sm={2} lg={2} xs={2}>
                <Box ml={1} mt={2}>
                  <Grid container>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                    <Grid md={4} sm={4} lg={4} xs={4}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        height={15}
                        width="70%"
                        style={{ marginBottom: 6 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : assistants.length == 0 ? (
        <Box display="flex" justifyContent="center">
          <Typography>{assistantMessage}</Typography>
        </Box>
      ) : (
        <Box mt={2} className={classes.paper}>
          <List dense={true}>
            {assistants.map((a) => {
              return (
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <Person />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={a["user_first_name"] + " " + a["user_last_name"]}
                    secondary={matches && a["user_nid"]}
                  />
                  <ListItemSecondaryAction>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        get_balance(a["user_phone"]);
                      }}
                      startIcon={<AccountBalanceWallet />}
                    >
                      {matches && "Balance"}
                    </Button>
                    <IconButton
                      edge="end"
                      aria-label="View"
                      onClick={() => {
                        get_assistant_info(a["user_id"]);
                      }}
                    >
                      <Visibility />
                    </IconButton>
                    <IconButton edge="end" aria-label="Edit">
                      <Edit />
                    </IconButton>
                    {a["user_status"] == "DISABLED" ? (
                      <IconButton
                        edge="end"
                        aria-label="Block"
                        onClick={() => {
                          setAssistantId(a["user_id"]);
                          setActiveDialog(true);
                        }}
                      >
                        <CheckCircleOutline color="primary" />
                      </IconButton>
                    ) : (
                      <IconButton
                        edge="end"
                        aria-label="Block"
                        onClick={() => {
                          setAssistantId(a["user_id"]);
                          handleOpenBlock();
                        }}
                      >
                        <Block />
                      </IconButton>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}

      {/* block user  */}

      <Dialog
        maxWidth="xs"
        fullWidth
        open={openBlock}
        onClose={handleCloseBlock}
        aria-labelledby="block_assistant"
        aria-describedby="block_assistant"
      >
        <DialogTitle>
          <Translate id="agent_assistant.block_user.title" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Translate id="agent_assistant.block_user.message" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBlock} color="secondary">
            <Translate id="agent_assistant.block_user.no" />
          </Button>

          <Button
            disableElevation
            onClick={() => {
              deactive_user();
            }}
            variant="contained"
            color="secondary"
          >
            {deactivateLoad ? (
              <CircularProgress size={25} />
            ) : (
              <Translate id="agent_assistant.block_user.block" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* new assistant */}

      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="new_user"
        aria-describedby="new_user"
      >
        <DialogTitle id="new_user">{"New Assistant"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={"Firstname"}
                    error={Fname.error != ""}
                    helperText={Fname.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setFname({ value: "", error: "Enter firstname" });
                      } else {
                        setFname({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={"Lastname"}
                    error={Lname.error != ""}
                    helperText={Lname.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setLname({ value: "", error: "Enter lastname" });
                      } else {
                        setLname({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={"Username"}
                    error={userName.error != ""}
                    helperText={userName.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setUsername({ value: "", error: "Enter username" });
                      } else {
                        setUsername({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={"Email"}
                    error={email.error != ""}
                    helperText={email.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setEmail({ value: "", error: "Enter email" });
                      } else {
                        setEmail({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={"Phone"}
                    error={phone.error != ""}
                    helperText={phone.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setPhone({ value: "", error: "Enter phone" });
                      } else {
                        setPhone({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  type="number"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={"NID"}
                    error={nid.error != ""}
                    helperText={nid.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setNid({ value: "", error: "Enter NID" });
                      } else {
                        setNid({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="gender">Gender</InputLabel>
                  <Select
                    size="small"
                    helperText={gender.error}
                    label="Select gender"
                    inputProps={{
                      name: "gender",
                      id: "gender",
                    }}
                    error={gender.error !== ""}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setGender({ value: "", error: "Select gender" });
                      } else {
                        setGender({ value: e.target.value, error: "" });
                      }
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"MALE"}>MALE</MenuItem>
                    <MenuItem value={"FEMALE "}>FEMALE </MenuItem>
                  </Select>
                  <FormHelperText error={gender.error !== ""}>
                    {gender.error}
                  </FormHelperText>
                </FormControl>
              </Box>

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="tole">User role</InputLabel>
                  <Select
                    size="small"
                    helperText={role.error}
                    label="Select User role"
                    inputProps={{
                      name: "role",
                      id: "role",
                    }}
                    error={role.error !== ""}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setRole({ value: "", error: "Select user role" });
                      } else {
                        setRole({ value: e.target.value, error: "" });
                      }
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {roles.map((r) => {
                      return (
                        <MenuItem value={r["role_id"]}>{r["name"]}</MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText error={role.error !== ""}>
                    {role.error}
                  </FormHelperText>
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  type="password"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    type="password"
                    variant="outlined"
                    label={"Password"}
                    error={password.error != ""}
                    helperText={password.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setPassword({ value: "", error: "Enter Password" });
                      } else {
                        setPassword({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>

              <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  type="password"
                  fullWidth
                  className={classes.formControl}
                >
                  <TextField
                    size="small"
                    type="password"
                    variant="outlined"
                    label={"PIN"}
                    error={pin.error != ""}
                    helperText={pin.error}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setPin({ value: "", error: "Enter PIN" });
                      } else {
                        setPin({ value: e.target.value, error: "" });
                      }
                    }}
                    color="primary"
                    fullWidth
                  />
                </FormControl>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              new_user();
            }}
            variant="contained"
            color="primary"
          >
            {newLoad ? (
              <CircularProgress color="secondary" size={25} />
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* reactive user  */}

      <Dialog
        maxWidth="xs"
        fullWidth
        open={activeDialog}
        onClose={() => {
          setActiveDialog(false);
        }}
        aria-labelledby="block_assistant"
        aria-describedby="block_assistant"
      >
        <DialogTitle>
          <Translate id="agent_assistant.active_user.title" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Translate id="agent_assistant.active_user.message" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setActiveDialog(false);
            }}
            color="secondary"
          >
            <Translate id="agent_assistant.active_user.no" />
          </Button>

          <Button
            disableElevation
            onClick={() => {
              active_user();
            }}
            variant="contained"
            color="primary"
          >
            {activeLoad ? (
              <CircularProgress size={25} />
            ) : (
              <Translate id="agent_assistant.active_user.activate" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* get assistant info  */}

      <Dialog
        maxWidth="sm"
        fullWidth
        open={infoDialog}
        onClose={() => {
          setActiveDialog(false);
        }}
        aria-labelledby="agent_information"
        aria-describedby="agent_information"
      >
        <DialogTitle>Agent Information</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                bp={1}
              >
                <Box
                  width={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  <AccountCircle color="secondary" style={{ fontSize: 60 }} />
                  <Typography>
                    {info["user_first_name"] + " " + info["user_last_name"]}
                  </Typography>
                  <Typography>{info["user_phone"]}</Typography>
                  <Typography>{info["user_gender"]}</Typography>
                  <Typography>{info["user_nid"]}</Typography>
                  <Typography>{info["user_email"]}</Typography>
                </Box>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setInfoDialog(false);
            }}
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* get assistant balance  */}

      <Dialog
        maxWidth="sm"
        fullWidth
        open={balanceDialog}
        onClose={() => {
          setBalanceDialog(false);
        }}
        aria-labelledby="agent_information"
        aria-describedby="agent_information"
      >
        <DialogTitle>Assistant Agent Balance</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {balanceLoad ? (
              <Box display="flex" justifyContent="center">
                <CircularProgress fontSize="large" />
              </Box>
            ) : (
              <Box>
                <Box
                  display="flex"
                  alignItems="flex-end"
                  p={1}
                  mt={1}
                  justifyContent="center"
                >
                  <Box
                    width="70%"
                    display="flex"
                    justifyContent="center"
                    p={1}
                    bgcolor="grey.300"
                  >
                    <Box>{balanceData.account_number_formatted}</Box>
                  </Box>
                </Box>

                <List>
                  <ListItem>
                    <ListItemAvatar>
                      <AccountBalanceWallet />
                    </ListItemAvatar>
                    <ListItemText
                      primary="Current Balance"
                      secondary={balanceData.current_balance + "FRW"}
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemAvatar>
                      <OpenInBrowser />
                    </ListItemAvatar>
                    <ListItemText
                      primary="Opening Balance"
                      secondary={balanceData.opening_balance + "FRW"}
                    />
                  </ListItem>

                  <ListItem>
                    <ListItemAvatar>
                      <CancelPresentation />
                    </ListItemAvatar>
                    <ListItemText
                      primary="Closing Balance"
                      secondary={balanceData.closing_balance + "FRW"}
                    />
                  </ListItem>
                </List>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setBalanceDialog(false);
            }}
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default withLocalize(Managers);
